module.exports = __webpack_public_path__ + "static/media/iconfinder_code-programming-javascript-software-develop-command-language_652581.3f9ca62f.svg";